import clsx from 'clsx';
import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { IPhone } from '../../../../../../models/Account/IPhone';
import { IBasicItem } from '../../../../../../models/IBasicItem';
import styles from './PhoneDropdown.module.css';

const PhoneDropdown = React.forwardRef<
  HTMLSelectElement,
  {
    items: IBasicItem[];
    label?: string;
    placeholderLabel?: string;
    selectedValue?: string;
    propStyle?: string;
    error?: boolean;
    required?: boolean;
  } & ReturnType<UseFormRegister<IPhone> & any>
>((props, ref) => {
  return (
    <div className={clsx(styles.container, props.propStyle)}>
      <label className={clsx(styles.label, props.error && styles.errorLabel)}>{props.label}</label>
      {props.required && <span style={{ color: 'var(--shrmRed)' }}>*</span>}
      <select
        className={clsx(styles.select, props.error && styles.error)}
        name={props.name}
        onChange={props.onChange}
        onBlur={props.onBlur}
        ref={ref}
        value={props.selectedValue ? props.selectedValue : undefined}
      >
        {props.placeholderLabel && <option value=''>{props.placeholderLabel}</option>}
        {props.items?.map((item: IBasicItem) => (
          <option value={item.value} key={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
});

export default PhoneDropdown;
